import { slugify } from '@/lib/sanitise-strings'
import React, { useCallback } from 'react'

import { RefinementList, Menu } from 'react-instantsearch'

type FilterRefinementListProps = {
  heading: string
  attribute: string
  radio?: boolean
}

const classNames = {
  list: 'w-full inline-flex flex-wrap gap-x-xxs gap-y-xxs',
  label:
    'filter-label font-normal text-14 flex items-center gap-x-xs py-xxs px-s border border-grey-300 hover:border-black cursor-pointer rounded-full transition-colors ms:py-[6px]',
  selectedItem: 'selected-filter',
  checkbox: 'sr-only',
  count: 'sr-only',
  showMore: 'mt-s text-12 text-grey-800 hover:text-primary [&:disabled]:hidden',
}

export default function FilterRefinementList({
  heading,
  attribute,
  radio = false,
}: FilterRefinementListProps): JSX.Element {
  const transformItems = useCallback(
    (items) =>
      items.map((item) => {
        const iconId = slugify(item.label)

        const icon = (
          <svg aria-hidden="true" className="h-[18px] w-[18px] shrink-0 text-inherit">
            <use href={`${process.env.NEXT_PUBLIC_SPRITE_ICONS_PATH}#icon-filter-${iconId}`}></use>
          </svg>
        )

        return {
          ...item,
          label: (
            <span className="flex items-center gap-x-xxxs">
              {icon}
              <span>{item.label}</span>
            </span>
          ),
        }
      }),
    [],
  )

  return (
    <div className="mt-[-1px] w-full border-t border-grey-300 p-m ms:p-s">
      {heading ? <h6 className="mb-xs">{heading}</h6> : null}

      {radio ? (
        <Menu
          attribute={attribute}
          sortBy={['name:asc']}
          showMore={true}
          showMoreLimit={999}
          limit={8}
          classNames={classNames}
        />
      ) : (
        <RefinementList
          attribute={attribute}
          operator="and"
          sortBy={['name:asc']}
          showMore={true}
          showMoreLimit={999}
          limit={8}
          classNames={classNames}
          // Add icon to labels
          transformItems={transformItems}
        />
      )}
    </div>
  )
}
